import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  showLoginModal: boolean;
}

const initialState: AuthState = {
  showLoginModal: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setShowLoginModal: (state: AuthState, action: PayloadAction<boolean>) => {
      state.showLoginModal = action.payload;
    },
  },
});

export const { setShowLoginModal } = authSlice.actions;
export default authSlice.reducer;
